<div class="py-4 px-0 material-view">
  <div class="container">
    @if (collectionIsLoading) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else {
      @if (collection) {
        <div class="row mb-4">
          <div class="col-lg-6">
            <h1>{{ collection.name }}</h1>
          </div>
          <div class="col-lg-6 text-lg-end">
            <div class="material-actions">
              @if (collection.owner) {
                <a class="btn btn-link" [routerLink]="['/kokoelma', collectionId, 'muokkaa']">
                  <i class="fa fa-fw fa-edit text-dark" aria-hidden="true"></i>
                  {{ "demo.educationalMaterial.edit" | translate }}
                </a>
              }
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-2 col-lg-3 text-center text-md-start">
            <img
              [src]="collection.thumbnail"
              class="img-fluid mb-4"
              [alt]="'demo.educationalMaterial.cover.alt' | translate" />
          </div>
          <!--left column-->
          <div class="col-md-10 col-lg-9">
            <ul class="list-unstyled collection-authors">
              @for (author of collection.authors; track author) {
                <li>{{ author }}</li>
              }
            </ul>
            <!--authors-->
            <div class="datetimes">
              <span class="datetime-item d-block d-md-inline-block">
                <strong>{{ "demo.educationalMaterial.createdAt" | translate }}:</strong>
                <time [attr.datetime]="collection.createdAt | date: 'yyyy-MM-dd HH:mm'">
                  {{ collection.createdAt | date: "d.M.yyyy HH:mm" }}
                </time>
              </span>
              @if (collection.publishedAt) {
                <span class="datetime-item d-block d-md-inline-block">
                  <strong>{{ "demo.educationalMaterial.publishedAt" | translate }}:</strong>
                  <time [attr.datetime]="collection.publishedAt | date: 'yyyy-MM-dd HH:mm'">
                    {{ collection.publishedAt | date: "d.M.yyyy HH:mm" }}
                  </time>
                </span>
              }
              @if (collection.updatedAt) {
                <span class="datetime-item d-block d-md-inline-block">
                  <strong>{{ "demo.educationalMaterial.updatedAt" | translate }}:</strong>
                  <time [attr.datetime]="collection.updatedAt | date: 'yyyy-MM-dd HH:mm'">
                    {{ collection.updatedAt | date: "d.M.yyyy HH:mm" }}
                  </time>
                </span>
              }
            </div>
            <!--/datetimes-->
            @if (collection.description) {
              <p>{{ collection.description }}</p>
            }
            <!--/description-->
            @if (collection.keywords?.length > 0) {
              <app-taglist
                elementId="collection-keywords"
                [tags]="collection.keywords"
                [title]="'collections.meta.keywords' | translate"
                property="value"
                searchProperty="key"
              filterType="keywords"></app-taglist>
            }
            <!--keywords-->
            <button
              type="button"
              class="btn btn-link px-0"
              (click)="detailsExpanded = !detailsExpanded"
              [attr.aria-expanded]="detailsExpanded"
              aria-controls="metadata">
              @if (detailsExpanded) {
                {{ "demo.educationalMaterial.expandMetadata.less" | translate }}
              } @else {
                {{ "demo.educationalMaterial.expandMetadata.more" | translate }}
              }
            </button>
            <!--toggle metadata-->
            <div id="metadata" [collapse]="!detailsExpanded" [isAnimated]="true">
              @if (collection.languages?.length > 0 && languages) {
                <app-taglist
                  elementId="collection-languages"
                  [tags]="languages"
                  [title]="'collections.meta.languages' | translate"
                  property="value"
                  searchProperty="key"
                filterType="languages"></app-taglist>
              }
              <!--languages-->
              @if (collection.educationalUses?.length > 0) {
                <app-taglist
                  elementId="collection-educationalUses"
                  [tags]="collection.educationalUses"
                  [title]="'collections.meta.educationalUses' | translate"
                  property="value"
                  searchProperty="key"
                filterType="educationalUses"></app-taglist>
              }
              <!--educationalUses-->
              @if (collection.educationalRoles?.length > 0) {
                <app-taglist
                  elementId="collection-educationalRoles"
                  [tags]="collection.educationalRoles"
                  [title]="'collections.meta.educationalRoles' | translate"
                  property="value"
                  searchProperty="key"
                filterType="educationalRoles"></app-taglist>
              }
              <!--educationalRoles-->
              @if (collection.accessibilityFeatures?.length > 0) {
                <app-taglist
                  elementId="collection-accessibilityFeatures"
                  [tags]="collection.accessibilityFeatures"
                  [title]="'collections.meta.accessibilityFeatures' | translate"
                  property="value"
                  searchProperty="key"
                filterType="accessibilityFeatures"></app-taglist>
              }
              <!--accessibilityFeatures-->
              @if (collection.accessibilityHazards?.length > 0) {
                <app-taglist
                  elementId="collection-accessibilityHazards"
                  [tags]="collection.accessibilityHazards"
                  [title]="'collections.meta.accessibilityHazards' | translate"
                  property="value"
                  searchProperty="key"
                filterType="accessibilityHazards"></app-taglist>
              }
              <!--accessibilityHazards-->
              @if (collection.educationalLevels?.length > 0) {
                <app-taglist
                  elementId="collection-educationalLevels"
                  [tags]="collection.educationalLevels"
                  [title]="'collections.meta.educationalLevels' | translate"
                  property="value"
                  searchProperty="key"
                filterType="educationalLevels"></app-taglist>
              }
              <!--educationalLevels-->
              <!--early childhood education-->
              @if (collection.earlyChildhoodEducationSubjects?.length > 0) {
                <app-taglist
                  elementId="collection-earlyChildhoodEducationSubjects"
                  [tags]="collection.earlyChildhoodEducationSubjects"
                  [title]="'collections.meta.earlyChildhoodEducationSubjects' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--earlyChildhoodEducationSubjects-->
              @if (collection.earlyChildhoodEducationObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-earlyChildhoodEducationObjectives"
                  [tags]="collection.earlyChildhoodEducationObjectives"
                  [title]="'collections.meta.earlyChildhoodEducationObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--earlyChildhoodEducationObjectives-->
              @if (collection.earlyChildhoodEducationFramework) {
                <strong class="h3 d-block mb-2" id="collection-earlyChildhoodEducationFramework">
                  {{ "collections.meta.earlyChildhoodEducationFramework" | translate }}
                </strong>
                <p aria-labelledby="collection-earlyChildhoodEducationFramework">
                  {{ collection.earlyChildhoodEducationFramework }}
                </p>
              }
              <!--earlyChildhoodEducationFramework-->
              <!--/early childhood education-->
              <!--pre primary education-->
              @if (collection.prePrimaryEducationSubjects?.length > 0) {
                <app-taglist
                  elementId="collection-prePrimaryEducationSubjects"
                  [tags]="collection.prePrimaryEducationSubjects"
                  [title]="'collections.meta.prePrimaryEducationSubjects' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--prePrimaryEducationSubjects-->
              @if (collection.prePrimaryEducationObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-prePrimaryEducationObjectives"
                  [tags]="collection.prePrimaryEducationObjectives"
                  [title]="'collections.meta.prePrimaryEducationObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--prePrimaryEducationObjectives-->
              @if (collection.prePrimaryEducationFramework) {
                <strong class="h3 d-block mb-2" id="collection-prePrimaryEducationFramework">
                  {{ "collections.meta.prePrimaryEducationFramework" | translate }}
                </strong>
                <p aria-labelledby="collection-prePrimaryEducationFramework">
                  {{ collection.prePrimaryEducationFramework }}
                </p>
              }
              <!--prePrimaryEducationFramework-->
              <!--/pre primary education-->
              <!--basic education-->
              @if (collection.basicStudySubjects?.length > 0) {
                <app-taglist
                  elementId="collection-basicStudySubjects"
                  [tags]="collection.basicStudySubjects"
                  [title]="'collections.meta.basicStudySubjects' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--basicStudySubjects-->
              @if (collection.basicStudyObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-basicStudyObjectives"
                  [tags]="collection.basicStudyObjectives"
                  [title]="'collections.meta.basicStudyObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--basicStudyObjectives-->
              @if (collection.basicStudyContents?.length > 0) {
                <app-taglist
                  elementId="collection-basicStudyContents"
                  [tags]="collection.basicStudyContents"
                  [title]="'collections.meta.basicStudyContents' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--basicStudyContents-->
              @if (collection.basicStudyFramework) {
                <strong class="h3 d-block mb-2" id="collection-basicStudyFramework">
                  {{ "collections.meta.basicStudyFramework" | translate }}
                </strong>
                <p aria-labelledby="collection-basicStudyFramework">{{ collection.basicStudyFramework }}</p>
              }
              <!--basicStudyFramework-->
              <!--/basic education-->
              <!-- preparatory education -->
              @if (collection.preparatoryEducationSubjects?.length > 0) {
                <app-taglist
                  elementId="collection-preparatoryEducationSubjects"
                  [tags]="collection.preparatoryEducationSubjects"
                  [title]="'collections.meta.preparatoryEducationSubjects' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              @if (collection.preparatoryEducationObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-preparatoryEducationObjectives"
                  [tags]="collection.preparatoryEducationObjectives"
                  [title]="'collections.meta.preparatoryEducationObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--preparatoryEducationObjectives-->
              <!--/preparatory education-->
              <!--upper secondary education-->
              @if (collection.upperSecondarySchoolSubjectsOld?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolSubjectsOld"
                  [tags]="collection.upperSecondarySchoolSubjectsOld"
                  [title]="'collections.meta.upperSecondarySchoolSubjects' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--upperSecondarySchoolSubjectsOld-->
              @if (collection.upperSecondarySchoolCoursesOld?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolCoursesOld"
                  [tags]="collection.upperSecondarySchoolCoursesOld"
                  [title]="'collections.meta.upperSecondarySchoolCourses' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--upperSecondarySchoolCoursesOld-->
              @if (collection.upperSecondarySchoolObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolObjectives"
                  [tags]="collection.upperSecondarySchoolObjectives"
                  [title]="'collections.meta.upperSecondarySchoolObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--upperSecondarySchoolObjectives-->
              @if (collection.upperSecondarySchoolFramework) {
                <strong class="h3 d-block mb-2" id="collection-upperSecondarySchoolFramework">
                  {{ "collections.meta.upperSecondarySchoolFramework" | translate }}
                </strong>
                <p aria-labelledby="collection-upperSecondarySchoolFramework">
                  {{ collection.upperSecondarySchoolFramework }}
                </p>
              }
              <!--upperSecondarySchoolFramework-->
              <!--/upper secondary education (old)-->
              <!--upper secondary education (new)-->
              @if (collection.upperSecondarySchoolSubjectsNew?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolSubjectsNew"
                  [tags]="collection.upperSecondarySchoolSubjectsNew"
                  [title]="'collections.meta.upperSecondarySchoolSubjectsNew' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--upperSecondarySchoolSubjectsNew-->
              @if (collection.upperSecondarySchoolModulesNew?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolModulesNew"
                  [tags]="collection.upperSecondarySchoolModulesNew"
                  [title]="'collections.meta.upperSecondarySchoolModulesNew' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--upperSecondarySchoolModulesNew-->
              @if (collection.upperSecondarySchoolObjectivesNew?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolObjectivesNew"
                  [tags]="collection.upperSecondarySchoolObjectivesNew"
                  [title]="'collections.meta.upperSecondarySchoolObjectivesNew' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--upperSecondarySchoolObjectivesNew-->
              @if (collection.upperSecondarySchoolContentsNew?.length > 0) {
                <app-taglist
                  elementId="collection-upperSecondarySchoolContentsNew"
                  [tags]="collection.upperSecondarySchoolContentsNew"
                  [title]="'collections.meta.upperSecondarySchoolContentsNew' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--upperSecondarySchoolContentsNew-->
              <!--/upper secondary education (new)-->
              <!--vocational education-->
              @if (collection.vocationalDegrees?.length > 0) {
                <app-taglist
                  elementId="collection-vocationalDegrees"
                  [tags]="collection.vocationalDegrees"
                  [title]="'collections.meta.vocationalDegrees' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--vocationalDegrees-->
              @if (collection.vocationalUnits?.length > 0) {
                <app-taglist
                  elementId="collection-vocationalUnits"
                  [tags]="collection.vocationalUnits"
                  [title]="'collections.meta.vocationalUnits' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--vocationalUnits-->
              @if (collection.subjectOfCommonUnit?.length > 0) {
                <app-taglist
                  elementId="collection-subjectOfCommonUnit"
                  [tags]="collection.subjectOfCommonUnit"
                  [title]="'collections.meta.vocationalCommonUnits' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--vocationalUnits-->
              @if (collection.vocationalRequirements?.length > 0) {
                <app-taglist
                  elementId="collection-vocationalRequirements"
                  [tags]="collection.vocationalRequirements"
                  [title]="'collections.meta.vocationalEducationObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--vocationalRequirements-->
              @if (collection.vocationalEducationFramework) {
                <strong class="h3 d-block mb-2" id="collection-vocationalEducationFramework">
                  {{ "collections.meta.vocationalEducationFramework" | translate }}
                </strong>
                <p aria-labelledby="collection-vocationalEducationFramework">
                  {{ collection.vocationalEducationFramework }}
                </p>
              }
              <!--vocationalEducationFramework-->
              <!--/vocational education-->
              <!--self-motivated education-->
              @if (collection.selfMotivatedEducationSubjects?.length > 0) {
                <app-taglist
                  elementId="collection-selfMotivatedEducationSubjects"
                  [tags]="collection.selfMotivatedEducationSubjects"
                  [title]="'collections.meta.selfMotivatedEducationSubjects' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--selfMotivatedEducationSubjects-->
              @if (collection.selfMotivatedEducationObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-selfMotivatedEducationObjectives"
                  [tags]="collection.selfMotivatedEducationObjectives"
                  [title]="'collections.meta.selfMotivatedEducationObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--selfMotivatedEducationObjectives-->
              <!--/self-motivated education-->
              <!--higher education-->
              @if (collection.scienceBranches?.length > 0) {
                <app-taglist
                  elementId="collection-scienceBranches"
                  [tags]="collection.scienceBranches"
                  [title]="'collections.meta.scienceBranches' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="educationalSubjects"></app-taglist>
              }
              <!--scienceBranches-->
              @if (collection.scienceBranchObjectives?.length > 0) {
                <app-taglist
                  elementId="collection-scienceBranchObjectives"
                  [tags]="collection.scienceBranchObjectives"
                  [title]="'collections.meta.scienceBranchObjectives' | translate"
                  property="targetName"
                  searchProperty="key"
                filterType="teaches"></app-taglist>
              }
              <!--scienceBranchObjectives-->
              @if (collection.higherEducationFramework) {
                <strong class="h3 d-block mb-2" id="collection-higherEducationFramework">
                  {{ "collections.meta.higherEducationFramework" | translate }}
                </strong>
                <p aria-labelledby="collection-higherEducationFramework">{{ collection.higherEducationFramework }}</p>
              }
              <!--higherEducationFramework-->
              <!--/higher education-->
            </div>
            <!--/metadata-->
            @if (collection.materialsAndHeadings?.length > 0) {
              @for (materialOrHeading of collection.materialsAndHeadings; track materialOrHeading; let i = $index) {
                <div
                  class="collection-material"
                  >
                  @if (materialOrHeading.id) {
                    @if (headingLevels.get(i) === 'h2') {
                      <h2 class="title">
                        <a [routerLink]="['/materiaali', materialOrHeading.id]">
                          {{ materialDetails.get(materialOrHeading.id).name[lang] }}
                        </a>
                      </h2>
                    } @else {
                      <h3 class="title">
                        <a [routerLink]="['/materiaali', materialOrHeading.id]">
                          {{ materialDetails.get(materialOrHeading.id).name[lang] }}
                        </a>
                      </h3>
                    }
                    <ul class="list-unstyled authors">
                      @for (author of materialDetails.get(materialOrHeading.id).authors; track author) {
                        <li>
                          @if (author.authorname !== '') {
                            {{ author.authorname }}
                            @if (author.organization) {
                              ({{ author.organization }})
                            }
                          } @else {
                            {{ author.organization }}
                          }
                        </li>
                      }
                    </ul>
                    <!--authors-->
                    @if (materialsLoading.get(materialOrHeading.id) === false) {
                      <div>
                        @if (collectionMaterials.get(materialOrHeading.id).length > 0) {
                          <div class="list-files mb-4">
                            <div class="row g-0">
                              <div class="col-3">
                                @if (materialLanguages.get(materialOrHeading.id).length > 1) {
                                  <h3 [id]="'selectLanguage' + materialOrHeading.id">
                                    {{ "materialPreview.selectLanguage" | translate }}
                                  </h3>
                                  <div
                                    class="btn-group mb-3"
                                    role="tablist"
                                    [attr.aria-labelledby]="'selectLanguage' + materialOrHeading.id">
                                    @for (lang of materialLanguages.get(materialOrHeading.id); track lang) {
                                      <button
                                        type="button"
                                        class="btn btn-gray"
                                        [ngClass]="lang === selectedLanguages.get(materialOrHeading.id) ? 'active' : ''"
                                        [attr.aria-selected]="lang === selectedLanguages.get(materialOrHeading.id)"
                                        [attr.aria-controls]="'fileList-' + materialOrHeading.id + '-' + lang"
                                        [id]="'langSelector-' + materialOrHeading.id + '-' + lang"
                                        role="tab"
                                        (click)="setSelectedLanguage(materialOrHeading.id, lang)">
                                        {{ lang }}
                                      </button>
                                    }
                                  </div>
                                }
                                @if (
                                  collectionMaterials.get(materialOrHeading.id)
                                  | materialLanguage: selectedLanguages.get(materialOrHeading.id); as materials
                                  ) {
                                  <div
                            [id]="
                              'fileList-' + materialOrHeading.id + '-' + selectedLanguages.get(materialOrHeading.id)
                            "
                            [attr.role]="materialLanguages.get(materialOrHeading.id).length > 1 ? 'tabpanel' : null"
                            [attr.aria-labelledby]="
                              materialLanguages.get(materialOrHeading.id).length > 1
                                ? 'langSelector-' + materialOrHeading.id + '-' + selectedLanguages.get(materialOrHeading.id)
                                : null
                            ">
                                    <h3
                                      [id]="'selectMaterial' + materialOrHeading.id"
                                      [ngClass]="materials.length === 1 ? 'visually-hidden' : ''">
                                      {{ "materialPreview.selectMaterial" | translate }}
                                    </h3>
                                    <div
                                      class="btn-group-vertical"
                                      role="tablist"
                                      [attr.aria-labelledby]="'selectMaterial' + materialOrHeading.id">
                                      @for (material of materials; track material) {
                                        <button
                                          type="button"
                                          class="btn btn-file text-dark"
                                          [ngClass]="material === previewMaterials.get(materialOrHeading.id) ? 'active' : ''"
                                          [attr.aria-selected]="material === previewMaterials.get(materialOrHeading.id)"
                                          [attr.aria-controls]="'filePreview-' + materialOrHeading.id + '-' + material.id"
                                          [id]="'fileSelector-' + materialOrHeading.id + '-' + material.id"
                                          role="tab"
                                          (click)="setPreviewMaterial(materialOrHeading.id, material)">
                                          {{ material.displayName[lang] }}
                                        </button>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                              <div class="col-9">
                                <div
                            [id]="
                              'filePreview-' +
                              materialOrHeading.id +
                              '-' +
                              previewMaterials.get(materialOrHeading.id).id
                            "
                                  role="tabpanel"
                            [attr.aria-labelledby]="
                              'fileSelector-' +
                              materialOrHeading.id +
                              '-' +
                              previewMaterials.get(materialOrHeading.id).id
                            ">
                                  @if (!previewMaterials.get(materialOrHeading.id).link) {
                                    <app-educational-material-preview
                                      [material]="previewMaterials.get(materialOrHeading.id)"
                                      [isCollection]="true"
                                    ></app-educational-material-preview>
                                  } @else {
                                    <div class="link-preview">
                                      <a
                                        [href]="previewMaterials.get(materialOrHeading.id).link"
                                        class="btn btn-secondary"
                                        target="_blank"
                                        rel="noopener nofollow">
                                        {{ "demo.educationalMaterial.preview.openInNewTab" | translate }} ({{
                                        previewMaterials.get(materialOrHeading.id).domain }})
                                      </a>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="spinner-border" role="status">
                        <span class="visually-hidden">{{ "collections.loading" | translate }}</span>
                      </div>
                    }
                  } @else {
                    <h2 class="title">{{ materialOrHeading.heading }}</h2>
                    @if (materialOrHeading.description) {
                      <p>{{ materialOrHeading.description }}</p>
                    }
                  }
                  <!--material-->
                  <!--heading-->
                </div>
              }
            } @else {
              <p>{{ "collections.noMaterials" | translate }}</p>
            }
            <!--/materials and headings a-->
            <!--no materials or headings-->
          </div>
          <!--/right column-->
        </div>
      }
    }

  </div>
</div>
